import React,{ Component } from 'react';
import { Col, Row } from 'reactstrap';
import { css } from 'aphrodite/no-important';
import { contentStyles } from './styles';
export default class Tile extends Component{
    render(){
        const { contentCol } = contentStyles;
        let newProps = !this.props.hasOwnProperty('className') ? {...this.props,className: `shadow-sm rounded mx-auto ${css(contentCol)} `}:{...this.props};
        return (
            <Row className="m-0">
                <Col {...newProps} />
            </Row>
        );
    }
}


// WEBPACK FOOTER //
// ./src/Components/App/Layout/Tile.js